import React, { useState } from 'react';

type FadeInContainerProps = {
	children: React.ReactNode;
	down?: boolean;
	className?: string;
	style?: React.CSSProperties;
};

const FADE_UP_CLASS = 'motion-safe:animate-fadeInUp';
const FADE_DOWN_CLASS = 'motion-safe:animate-fadeInDown';

const FadeInContainer = ({ children, down = false, className = '', style }: FadeInContainerProps) => {
	// The animations use `forwards`, so their transform would otherwise persist and make
	// this the containing block for fixed-position descendants such as sheets and modals.
	const [hasFadedIn, setHasFadedIn] = useState(false);
	const fadeClass = hasFadedIn ? '' : (down ? FADE_DOWN_CLASS : FADE_UP_CLASS);

	return (
		<div
			className={`min-h-[10vh] ${fadeClass} ${className}`.trim()}
			style={style}
			onAnimationEnd={(event) => {
				if (event.target === event.currentTarget) setHasFadedIn(true);
			}}
		>
			{children}
		</div>
	);
};

export default FadeInContainer;
